import React from "react";
import { SharedSelect } from "../../../../../sharedComponents/SharedSelect";
import { InputField } from "../../../../../sharedComponents/InputField";
import { TextArea } from "../../../../../sharedComponents/TextArea";
import { SharedButton } from "../../../../../sharedComponents/Button";
import { Container, Row, Col, Form } from "react-bootstrap";
import { useEffect } from "react";
import { InstructorList, add_shift, get_room_location, get_weekdays } from "../../../../../Studio-Services/Studio_Services";
import { useState } from "react";
import moment from "moment";
import Swal from "sweetalert2";
import logo from "../../../../../Images/logo_white_web.png"
import { FaRegCalendarAlt } from "react-icons/fa";


export const AddShiftNew = ({ setLoader }) => {
    const [listInt, setListInt] = useState([]);
    const [locationOp, setLocationOp] = useState([]);

    const [wekList, setWekList] = useState([]);
    const [selectedDayId, setSelectedDayId] = useState();
    const [selectedDay, setSelectedDay] = useState();


    const [startDate, setStartDate] = useState("");
    const [sTime, setSTime] = useState("");
    const [eTime, setETime] = useState("");

    const DateChange = (e) => {
        const value = e.target.value;

        setStartDate(value);
        setError((prev) => ({ ...prev, start_date: "" }));

        const selectedDay = moment(value, "YYYY-MM-DD").format("dddd");

        const day = wekList.find((item) => item.week_name === selectedDay);

        setSelectedDay(day?.week_name || "");
        setSelectedDayId(day?.id || "");
    };



    const getWeekdays = async () => {
        const resp = await get_weekdays();
        if (resp) {
            setWekList(resp.data.data);
        }
    };



    const getInstructor = async () => {
        const data = {
            "pageid": 1
        }
        const resp = await InstructorList(data);
        if (resp) {
            let op = [];
            (resp.data.data).forEach(e => {
                if (e.status === "Approve" && e.business_status === "Active") {
                    op.push({
                        value: e.user_id, label: `${e.name} ${e.lastname}`
                    })
                }
            });
            setListInt(op);
        }
    }


    const getRoomLocation = async () => {
        const data = {
            "business_id": localStorage.getItem("business_id")
        }
        const resp = await get_room_location(data);
        if (resp) {
            const lo = [];
            (resp.data.data).map((e) => {
                lo.push({
                    value: e.location_id, label: e.location_name
                })
            })
            setLocationOp(lo);
        }
    }


    useEffect(() => {
        getInstructor();
        getRoomLocation();
        getWeekdays();
    }, [])



    const startH = [
        { value: "01", label: <>01</> },
        { value: "02", label: <>02</> },
        { value: "03", label: <>03</> },
        { value: "04", label: <>04</> },
        { value: "05", label: <>05</> },
        { value: "06", label: <>06</> },
        { value: "07", label: <>07</> },
        { value: "08", label: <>08</> },
        { value: "09", label: <>09</> },
        { value: "10", label: <>10</> },
        { value: "11", label: <>11</> },
        { value: "12", label: <>12</> },
    ]
    const startM = [
        { value: "00", label: <>00 </> },
        { value: "05", label: <>05 </> },
        { value: "10", label: <>10 </> },
        { value: "15", label: <>15 </> },
        { value: "20", label: <>20 </> },
        { value: "25", label: <>25 </> },
        { value: "30", label: <>30 </> },
        { value: "35", label: <>35 </> },
        { value: "40", label: <>40 </> },
        { value: "45", label: <>45 </> },
        { value: "50", label: <>50 </> },
        { value: "55", label: <>55 </> },
    ]
    const startAM = [
        { value: "AM", label: <>AM</> },
        { value: "PM", label: <>PM</> },
    ]

    const payTypeOp = [
        { value: "Hourly", label: <>Hourly </> },
        { value: "Per Service", label: <>Per Service </> },
        { value: "Flat Rate", label: <>Flat Rate </> }
    ]

    const shiftOp = [
        { value: "1", label: <>Service Shift </> },
        { value: "2", label: <>Non-Service Shift </> },
    ]



    const [error, setError] = useState({
        shift_name: "",
        start_date: "",
        sHours: "",
        sMinuts: "",
        sAMPM: "",
        eHours: "",
        eMinuts: "",
        eAMPM: "",
        instructor: "",
        repeat: "",
        duration: "",
        description: "",
        pay_type: "",
        pay_rate: "",
        location: ""
    });

    const errorHandler = (e) => {
        const { name } = e.target;
        setError((pre) => ({ ...pre, [name]: "" }))
    }

    const submitHandler = async (e) => {
        e.preventDefault();
        const fData = new FormData(e.target);
        const fValue = Object.fromEntries(fData.entries());
        let isValid = 1;

        if (!sTime) {
            setError((prev) => ({ ...prev, sHours: "* Required" }));
            isValid = 2;
        }

        if (!eTime) {
            setError((prev) => ({ ...prev, eHours: "* Required" }));
            isValid = 3;
        }

        const startMoment = moment(sTime, "HH:mm", true);
        const endMoment = moment(eTime, "HH:mm", true);

        let durations = 0;
        let classStartTime = 0;
        let classEndTime = 0;

        if (!startDate) {
            setError((prev) => ({
                ...prev,
                start_date: "* Required",
            }));
            isValid = 0;
        }

        if (!sTime || !startMoment.isValid()) {
            setError((prev) => ({
                ...prev,
                sHours: "* Required",
            }));
            isValid = 0;
        }

        if (!eTime || !endMoment.isValid()) {
            setError((prev) => ({
                ...prev,
                eHours: "* Required",
            }));
            isValid = 0;
        }

        if (
            sTime &&
            eTime &&
            startMoment.isValid() &&
            endMoment.isValid()
        ) {
            if (endMoment.isSameOrBefore(startMoment)) {
                setError((prev) => ({
                    ...prev,
                    eHours: "End time must be after start time",
                }));

                isValid = 0;
            } else if (startDate) {
                const startDateTime = moment(
                    `${startDate} ${sTime}`,
                    "YYYY-MM-DD HH:mm",
                    true
                );

                const endDateTime = moment(
                    `${startDate} ${eTime}`,
                    "YYYY-MM-DD HH:mm",
                    true
                );

                classStartTime = startDateTime.unix();
                classEndTime = endDateTime.unix();

                durations = endDateTime.diff(startDateTime, "minutes");
            }
        }
        const shift_name = fValue.shift_name;
        const start_date = startDate;
        const instructor = fValue.instructor;
        const repeat = fValue.repeat || 0;
        const description = fValue.description;
        const pay_type = fValue.pay_type;
        const pay_rate = fValue.pay_rate;
        const location = fValue.location;


        if (!shift_name) { setError((pre) => ({ ...pre, shift_name: "* Required" })); isValid = 7; }
        if (!start_date) { setError((pre) => ({ ...pre, start_date: "* Required" })); isValid = 8; }
        if (!instructor) { setError((pre) => ({ ...pre, instructor: "* Required" })); isValid = 9; }
        if (!description) { setError((pre) => ({ ...pre, description: "* Required" })); isValid = 11; }
        if (!pay_type) { setError((pre) => ({ ...pre, pay_type: "* Required" })); isValid = 12; }
        if (!pay_rate) { setError((pre) => ({ ...pre, pay_rate: "* Required" })); isValid = 13; }
        if (!location) { setError((pre) => ({ ...pre, location: "* Required" })); isValid = 14; }

        let finalRepeat = 0;
        if (repeat != 0) { finalRepeat = parseInt(repeat) - 1; }

        if (isValid === 1) {
            setLoader(true);
            const payload = {
                shift_name: fValue.shift_name,
                day_id: selectedDayId,
                start_date: moment(startDate, "YYYY-MM-DD", true).startOf("day").unix(),
                start_time: classStartTime,
                end_time: classEndTime,
                instructor: fValue.instructor,
                repeat: finalRepeat,
                duration: durations,
                description: fValue.description,
                pay_type: fValue.pay_type,
                pay_rate: fValue.pay_rate,
                location: fValue.location,
            }
            const resp = await add_shift(payload);
            if (resp) {
                setLoader(false);
                // Reset the form after processing
                e.target.reset();
                Swal.fire({
                    html: `<img src=${logo} class="img-fluid d-block mx-auto mt-5" />
                        <h4 class="title text-capitalize text-center mt-4 textWhite">
                                Success
                        </h4>
                        <p class="text-center my-4 textcolor">
                        <small class="textWhite">
                        ${resp.data.message} </small></p>
                        `,
                    showClass: {
                        popup: "custom-dialog-container",
                    },
                    customClass: {
                        confirmButton: "custom-button custom-button-size modalbtn",
                    },
                });
            } else {
                setLoader(false);
            }
        }
    }
    return (
        <>

            <div className="innercontent">
                <h4>ADD SHIFTS</h4>
                <Container>
                    <Form onSubmit={submitHandler}>
                        <Row className="mt-4">
                            <Col lg={4} sm={12} className="mt-3">
                                <SharedSelect
                                    className={'form-select border2Px'}
                                    options={shiftOp}
                                    name={"shift_name"}
                                    error={error.shift_name}
                                    onChange={errorHandler}
                                    lable={"Service Shift"}
                                />
                            </Col>

                            <Col lg={4} sm={12} className="mt-3">
                                <SharedSelect
                                    className={'form-select border2Px'}
                                    options={listInt}
                                    name={"instructor"}
                                    error={error.instructor}
                                    onChange={errorHandler}
                                    lable={"Select Instructor"} />
                            </Col>

                            <Col lg={4} sm={12} className="mt-3">
                                <SharedSelect
                                    className={'form-select border2Px'}
                                    options={locationOp}
                                    name={"location"}
                                    error={error.location}
                                    onChange={errorHandler}
                                    lable={"Select Room Location"} />
                            </Col>



                        </Row>


                        <Row className="mt-3 mb-3">
                            {/* Start Date */}
                            <Col lg={4} sm={12}>
                                <Form.Label className="form-label inputLable">
                                    Start Date
                                </Form.Label>

                                <div className="position-relative">
                                    <Form.Control
                                        type="text"
                                        value={
                                            startDate
                                                ? moment(startDate, "YYYY-MM-DD").format("dddd, D MMMM")
                                                : ""
                                        }
                                        placeholder="Select date"
                                        readOnly
                                        onClick={() =>
                                            document.getElementById("shiftStartDatePicker")?.showPicker()
                                        }
                                        style={{
                                            cursor: "pointer",
                                            paddingRight: "45px",
                                            border: "2px solid #222",
                                        }}
                                    />

                                    <FaRegCalendarAlt
                                        size={22}
                                        onClick={() =>
                                            document.getElementById("shiftStartDatePicker")?.showPicker()
                                        }
                                        style={{
                                            position: "absolute",
                                            right: "16px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer",
                                            color: "#555",
                                            zIndex: 2,
                                        }}
                                    />

                                    <Form.Control
                                        id="shiftStartDatePicker"
                                        type="date"
                                        name="start_date"
                                        value={startDate}
                                        onChange={DateChange}
                                        className="position-absolute top-0 start-0 w-100 h-100 opacity-0"
                                        style={{ cursor: "pointer", zIndex: 3 }}
                                        aria-label="Select start date"
                                    />
                                </div>

                                <small className="text-danger">{error.start_date}</small>
                            </Col>

                            {/* Start Time */}
                            <Col lg={4} sm={12}>
                                <Form.Label className="form-label inputLable">
                                    Start Time
                                </Form.Label>

                                <Form.Control
                                    type="time"
                                    name="sTime"
                                    step={300}
                                    value={sTime}
                                    onChange={(e) => {
                                        setSTime(e.target.value);
                                        setError((prev) => ({
                                            ...prev,
                                            sHours: "",
                                            sMinuts: "",
                                            sAMPM: "",
                                        }));
                                    }}
                                    style={{ border: "2px solid #222" }}
                                />

                                {(
                                    error.sHours ||
                                    error.sMinuts ||
                                    error.sAMPM
                                ) && (
                                        <small className="text-danger">
                                            Please select start time
                                        </small>
                                    )}
                            </Col>

                            {/* End Time */}
                            <Col lg={4} sm={12}>
                                <Form.Label className="form-label inputLable">
                                    End Time
                                </Form.Label>

                                <Form.Control
                                    type="time"
                                    name="eTime"
                                    step={900}
                                    value={eTime}
                                    onChange={(e) => {
                                        setETime(e.target.value);
                                        setError((prev) => ({
                                            ...prev,
                                            eHours: "",
                                            eMinuts: "",
                                            eAMPM: "",
                                        }));
                                    }}
                                    style={{ border: "2px solid #222" }}
                                />

                                {(
                                    error.eHours ||
                                    error.eMinuts ||
                                    error.eAMPM
                                ) && (
                                        <small className="text-danger">
                                            Please select end time
                                        </small>
                                    )}
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={4} sm={12} className="mt-3">
                                <InputField
                                    name={"repeat"}
                                    minLength={"1"}
                                    lable={"Number of Weeks Shift will repeat"}
                                    type={"number"}
                                    error={error.repeat}
                                    onChange={errorHandler}
                                />
                            </Col>
                            <Col lg={4} sm={12} className="mt-3">
                                <SharedSelect
                                    className={'form-select border2Px'}
                                    name={"pay_type"}
                                    options={payTypeOp}
                                    error={error.pay_type}
                                    onChange={errorHandler}
                                    lable={"Pay Type"} />
                            </Col>

                            <Col lg={4} sm={12} className="mt-3">
                                <InputField
                                    name={"pay_rate"}
                                    minLength={"0"}
                                    lable={"Pay Rate"}
                                    type={"number"}
                                    error={error.pay_rate}
                                    onChange={errorHandler}
                                    placeholder={"$ 10"}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={12} sm={12}>
                                <TextArea
                                    name={"description"}
                                    lable={"Description"}
                                    error={error.description}
                                    onChange={errorHandler}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col lg={4}>
                                <SharedButton title={"SAVE"} type={"submit"} className={"btn btn-primary w-100"} />
                            </Col>
                            <Col lg={4}>
                                <SharedButton title={"BACK"} type={"button"} href={"/list-shifts"} className={"btn btn-outline w-100"} />

                            </Col>
                            <Col lg={4}></Col>
                        </Row>
                    </Form>
                </Container>
            </div>
        </>
    );
};
